import {
    apiRequest,
    mappingBknCreate, 
    mappingBknPositionList, 
    mappingBknUpdate
} from "../../../../../services/adapters/kepegawaian/mappingBknService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", mappingBknCreate, {
            body: query
        }, true)
    }

    fetchPosition = async (query) => {
        return await apiRequest("get", mappingBknPositionList, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", mappingBknUpdate, {
            body: query
        }, true)
    }

}

export default CreateRepository